import _hasUnicode_default from "./_hasUnicode.js";
import _asciiToArray_default from "./_asciiToArray.js";
import _unicodeToArray_default from "./_unicodeToArray.js";

//#region ../../node_modules/lodash-es/_stringToArray.js
/**
* Converts `string` to an array.
*
* @private
* @param {string} string The string to convert.
* @returns {Array} Returns the converted array.
*/
function stringToArray(string) {
	return _hasUnicode_default(string) ? _unicodeToArray_default(string) : _asciiToArray_default(string);
}
var _stringToArray_default = stringToArray;

//#endregion
export { _stringToArray_default as default };
//# sourceMappingURL=_stringToArray.js.map